import React from 'react';
import propTypes from 'prop-types';
export const BedIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      height={sizeInPixel}
      width={sizeInPixel}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M478.609,225.685V139.13c0-46.032-37.446-83.478-83.478-83.478H116.87c-46.032,0-83.478,37.446-83.478,83.478v86.555
           C14,232.599,0,250.959,0,272.696c0,32.729,0,62.199,0,100.174c0,9.223,7.479,16.696,16.696,16.696h16.696v50.087
           c0,9.223,7.479,16.696,16.696,16.696h66.783c9.217,0,16.696-7.473,16.696-16.696v-50.087h244.87v50.087
           c0,9.223,7.479,16.696,16.696,16.696h66.783c9.217,0,16.696-7.473,16.696-16.696v-50.087h16.696
           c9.217,0,16.696-7.473,16.696-16.696c0-38.33,0-66.813,0-100.174C512,250.959,498,232.599,478.609,225.685z M100.174,205.913
           c0-27.619,22.468-50.087,50.087-50.087h72.348c12.875,0,24.509,5.018,33.391,13.027c8.882-8.009,20.517-13.027,33.391-13.027
           h72.348c27.619,0,50.087,22.468,50.087,50.087v16.696h-33.391v-16.696c0-9.206-7.49-16.696-16.696-16.696h-72.348
           c-9.206,0-16.696,7.49-16.696,16.696v16.696h-33.391v-16.696c0-9.206-7.49-16.696-16.696-16.696h-72.348
           c-9.206,0-16.696,7.49-16.696,16.696v16.696h-33.391V205.913z M478.609,289.391H33.391v-16.696c0-9.206,7.49-16.696,16.696-16.696
           c151.085,0,259.331,0,411.826,0c9.206,0,16.696,7.49,16.696,16.696V289.391z"
          />
        </g>
      </g>
    </svg>
  );
};
BedIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
BedIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
